import visitorsClassicScenario from './visitors-classic';

/**
 * @param {object} server Mirage Server
 */
export default function (server) {
  const { locations, company } = visitorsClassicScenario(server);

  const externalCompany = server.create('company', {
    name: 'Buy and Large',
  });

  // create external company with many tenants
  const property = server.create('zone', 'asProperty', 'withTenantsWithInvites', {
    company: externalCompany,
  });

  const [tenant] = server.schema.tenants.where({ propertyId: property.id }).models;

  // link first tenant with one of the internal locations
  tenant.update({
    location: locations[0],
  });

  return {
    externalCompany,
    property,
    tenant,
    locations,
    company,
  };
}
